import { TextField } from "@mui/material";
import "./index.scss";

const InputBox = ({
  label,
  value = "",
  onChange,
  onBlur,
  type = "text",
  placeholder = "",
  error = false,
  helperText = "",
  disabled = false,
  required = false,
  fullWidth = false,
  size = "medium",
  variant = "outlined",
  className = "",
  maxLength,
  pattern,
  inputMode,
  multiline = false,
  rows = 1,
  startAdornment,
  endAdornment,
  ...otherProps
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  const handleBlur = (e) => {
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <TextField
      label={label}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      type={type}
      placeholder={placeholder}
      error={error}
      helperText={helperText}
      disabled={disabled}
      required={required}
      fullWidth={fullWidth}
      size={size}
      variant={variant}
      className={`input-box ${className}`}
      multiline={multiline}
      rows={multiline ? rows : undefined}
      InputProps={{
        startAdornment,
        endAdornment,
        inputProps: {
          maxLength,
          pattern,
          inputMode,
        },
      }}
      {...otherProps}
    />
  );
};

export default InputBox;
